// extracted by mini-css-extract-plugin
export default {"heading":"qt-z","corrected":"rt-z","redirectVerbiageContainer":"st-z","redirectVerbiageText":"tt-z"};